export const renderSubscriptionField = props => {
  return [
    {
      name: 'subscriptionName',
      type: 'text',
      defaultValue: props?.subscriptionName || '',
      isRequired: 'true',
      columnType: { lg: '12' },
      dataTestId: 'qa-subscription-name',
      customDataTestId: 'qa-subscription-wrapper',
      placeholderKey: 'subscriptionName',
      handleValueChange: props?.handleValueChange,
      minLenght: 1,
      maxLength: 50,
    },
  ]
}
